import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=39ce7d24&"
import script from "./PanelHeader.vue?vue&type=script&lang=ts&"
export * from "./PanelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PanelHeader.vue?vue&type=style&index=0&id=39ce7d24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports